import ChartSvg from './ChartSvg';

export default ChartSvg;